import React from 'react';
import Button from 'react-bootstrap/Button';
import CustomSpinner from './CustomSpinner';
import { isPermission } from '../../utils/common';



export default function CustomButton(props) {
  const { 
    variant,
    classNames,
    isLoading,
    text,
    handleClick,
    styles,
    size,
    isDisabled,
    icon,
    slug,
    htmlFor

  } = props
  const hasPermission = slug ? isPermission(slug.trim()) : true;
  return (<>
     {hasPermission&&<Button
      className={classNames || 'btn-primary text-white'}
      variant={variant || ''}
      disabled={isDisabled || isLoading}
      onClick={!isLoading ? handleClick : null}
      style={styles || { display: "flex", justifyContent: "center", alignItems:"center", gap: "5px" }}
      htmlFor={htmlFor||''}
    >
       {icon} {text}
      <CustomSpinner isShow={isLoading}  size={size ||'sm'} />
    </Button>}
    </>
  )
}